class FacetCount extends window.BAO.CustomElement({
  SuperClass: HTMLSpanElement,
}) {
  constructor () {
    super()

    switch (this.dataset.type) {
      case 'search':
        this.eventBus = window.theme.searchResults.eventBus
        this.state = {
          root: window.theme.searchResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      case 'autocomplete':
        this.eventBus = window.theme.autocompleteResults.eventBus
        this.state = {
          root: window.theme.autocompleteResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      default:
        // Default is collection
        this.eventBus = window.theme.category.eventBus
        this.state = {
          root: window.theme.category?.stateLayer?.state || { products: [] },
          observer: null,
        }
    }
  }

  connectedCallback () {
    this.subscribeToEvents()
  }

  subscribeToEvents () {
    this.eventBus.subscribe('state:activeFacets:updated', () => {
      if (this.count > 0) {
        this.innerHTML = ` (${this.count})`
      } else {
        this.innerHTML = ''
      }
    })

    this.eventBus.subscribe('api:facets:fetched', () => {
      if (this.count > 0) {
        this.innerHTML = ` (${this.count})`
      } else {
        this.innerHTML = ''
      }
    })
  }

  get count () {
    if (!this.state.root.activeFacets) return 0
    const activeFacets = this.state.root.activeFacets

    let totalValues = 0

    for (const facet of activeFacets) {
      if (facet.key === 'klevu_price') {
        totalValues += 1
      } else {
        if (facet.values && Array.isArray(facet.values)) {
          totalValues += facet.values.length
        }
      }
    }

    return totalValues
  }
}

window.customElements.define('facet-count', FacetCount, {
  extends: 'span',
})
